import { css } from '@emotion/react';
import { colors } from '../../../theme/colors';

/**
 * Shared surface treatment for every card/panel on the Sourcing profile page.
 *
 * Mirrors the Figma design tokens:
 *   - radius/xs
 *   - border/default/card
 *   - fill/card-and-table (radial gradient)
 *
 * Gradient sizing rationale:
 *   Figma's radial fill is a rotated ellipse whose horizontal handle lands on
 *   the card's bottom-right corner (normalized (1, 1)) and whose vertical
 *   handle lands at normalized (-1, 2.045). CSS `radial-gradient(<x> <y> at …)`
 *   takes axis-aligned radii, so we use the *projections* of those handles on
 *   each axis: 100% on X and 204.54% on Y.
 *
 *   This matches the canonical translucent-card gradient defined in
 *   `theme/component-styles.ts#transparentBgStyle` (`100% 204.54% at 0% 0%`)
 *   that is reused across CompanyProfiles2, DealFlow, the shared `Card`
 *   component and ~15 other places, so Sourcing panels read consistently with
 *   the rest of the app.
 *
 * CSS custom properties stay in front of the literal fallbacks so a
 * design-token theme (if/when wired up) can override them without touching
 * the consuming components.
 */
export const panelSurfaceCss = css`
  border-radius: var(--radius-xs, 4px);
  border: 0.5px solid var(--border-default-card, ${colors.border.card});
  background: var(
    --fill-card-and-table,
    radial-gradient(
      100% 204.54% at 0% 0%,
      var(--bg-linear-card_table-1, rgba(249, 250, 250, 0.8)) 0%,
      var(--bg-linear-card_table-2, rgba(255, 255, 255, 0.32)) 100%
    )
  );
`;
